import React from "react";
import { Placeholder } from "@sitecore-jss/sitecore-jss-react";
import Helmet from "react-helmet";
import { ToastContainer } from "react-toastify";
import { connect } from "react-redux";
import { getWindow } from "ssr-window";
import i18n from "i18next";

import SiderBar from "@/react-components/SiderBar";
import Header from "@/react-components/Header";
import Footer from "@/react-components/Footer";
import MainDetail from "@/react-components/MainDetail";
import NewsReleaseDetail from "@/react-components/NewsReleaseDetail";
import InformationDetail from "@/react-components/InformationDetail";
import ConfirmUpdateMask from "@/react-components/ConfirmUpdateMask";
import ConfirmFooter from "@/react-components/Confirm/Footer";
import { updateRouter as updateRouterDispatch } from "@/models/config";
import {
  getMenuBadgeInfo as getMenuBadgeInfoDispatch,
  getInformationBadgeInfo as getInformationBadgeInfoDispatch,
  // 課金-ADD-START
  getHeaderInfo as getHeaderInfoDispatch,
  // 課金-ADD-END
} from "@/models/user";
import {
  authStateEnum,
  modeEnum,
  firstLoginStatusEnum,
  updateStatusEnum,
} from "@/utils/enum";
import { scrollTop, isEmpty, isMobile, isIEBrowser } from "@/utils";
import url from "@/utils/url";

import "bootstrap/dist/css/bootstrap.css";
import "react-toastify/dist/ReactToastify.css";

import "@/assets/reset.css";
import "@/assets/app.css";
import "@/assets/app.scss";

class Layout extends React.Component {
  componentDidMount() {
    this.updateRouter();
    this.getBadgeInfo();
    this.updatePageEditingStyle();
  }

  UNSAFE_componentWillUpdate(nextProps, nextState) {
    const { router, route } = nextProps;
    if (this.props.router !== router || this.props.route !== route) {
      this.beforeRenderUpdateRouter(nextProps);
    }
    if (this.props.router !== router) {
      this.updateReferrer(this.props);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { router, route } = this.props;
    if (prevProps.router !== router || prevProps.route !== route) {
      this.updateRouter();
    }
    if (prevProps.router !== router) {
      this.updateReferrer(prevProps);
      this.getBadgeInfo();
    }
  }

  beforeRenderUpdateRouter = (nextProps) => {
    const { updateRouter, router, route } = nextProps;
    updateRouter({
      path: router?.location?.pathname,
      title: route?.fields?.title?.value,
    });
  };

  updateRouter = () => {
    const { updateRouter, router, route } = this.props;
    updateRouter({
      path: router?.location?.pathname,
      title: route?.fields?.title?.value,
    });
    scrollTop();
  };

  updateReferrer = (prevProps) => {
    const state = getWindow()?.history?.state || {};
    state.referrer = prevProps.router.location.pathname;
    getWindow().history.replaceState(state, "");
  };

  getBadgeInfo = () => {
    const {
      getMenuBadgeInfo,
      getInformationBadgeInfo,
      // 課金-ADD-START
      getHeaderInfo,
      // 課金-ADD-END
      scMode,
    } = this.props;
    const isNormal = scMode === modeEnum.normal;
    if (this.isShowLayout() && isNormal) {
      // メニューバッジ取得
      getMenuBadgeInfo();
      // お知らせバッジ取得
      getInformationBadgeInfo();
      // 課金-ADD-START
      // 共通ヘッダー情報取得処理
      getHeaderInfo();
      // 課金-ADD-END
    }
  };

  isShowLayout = () => {
    const {
      state,
      firstLoginStatus,
      companyUpdateStatus,
      userProfileUpdateStatus,
      agreementStatusInfo,
      scMode,
      route,
    } = this.props;
    const isNotFirstLogin = firstLoginStatus === firstLoginStatusEnum.notFirst;
    const isUpdate = companyUpdateStatus === updateStatusEnum.updated;
    const isUserUpdate = userProfileUpdateStatus === updateStatusEnum.updated;
    const isAgree =
      !isEmpty(agreementStatusInfo?.termsAgreementInfo?.termsOfServiceVer) &&
      !isEmpty(agreementStatusInfo?.termsAgreementInfo?.privacyPolicyVer) &&
      !isEmpty(agreementStatusInfo?.termsAgreementInfo?.contactFeatureVer);
    const isAuth0 = state === authStateEnum.auth0;
    const isWeb = state === authStateEnum.web;
    const isLogin = isAuth0 || isWeb;
    const isExtra =
      route.templateName === "NewPage" || route.templateName === "Lppage";
    const isNormal = scMode === modeEnum.normal;
    const isShow =
      ((isNormal &&
        isLogin &&
        ((isWeb && isUpdate && isUserUpdate) ||
          (isAuth0 &&
            isAgree &&
            isNotFirstLogin &&
            isUpdate &&
            isUserUpdate))) ||
        !isNormal) &&
      !isExtra;

    return isShow;
  };

  updatePageEditingStyle = () => {
    const { scMode } = this.props;
    if (scMode === modeEnum.pageEditing) {
      document.getElementById("root").style.overflow = "visible";
      document.getElementById("content").style.overflowX = "visible";
      if (document.getElementById("content-main-container")) {
        document.getElementById("content-main-container").style.overflow =
          "visible";
      }
    }
  };

  // jss-main プレースホルダレンダリング
  mainPlaceholderRender = (components, data, props) => {
    const { currentRouter } = this.props;
    if (
      currentRouter &&
      (props?.rendering?.fields?.isReport?.value ||
        props?.rendering?.fields?.isLibrary?.value)
    ) {
      return (
        <MainDetail data={data} props={props} showCommonFooter={true}>
          {components}
        </MainDetail>
      );
    }
    return components;
  };

  // jss-news-main プレースホルダレンダリング
  newsMainPlaceholderRender = (components, data, props) => {
    const { currentRouter } = this.props;
    if (currentRouter) {
      return (
        <NewsReleaseDetail data={data} props={props}>
          {components}
        </NewsReleaseDetail>
      );
    }
    return null;
  };

  // jss-notice-main プレースホルダレンダリング
  noticeMainPlaceholderRender = (components, data, props) => {
    const { currentRouter } = this.props;
    if (currentRouter) {
      return (
        <InformationDetail data={data} props={props}>
          {components}
        </InformationDetail>
      );
    }
    return null;
  };

  render() {
    const {
      state,
      title,
      scMode,
      router,
      router: {
        location: { pathname },
      },
      route,
      route: { placeholders },
      sitecoreContext,
    } = this.props;
    const isWeb = state === authStateEnum.web;
    const isNormal = scMode === modeEnum.normal;
    const isShow = this.isShowLayout();
    const isConfirm =
      [
        url.confirmAgreement,
        url.confirmPrivacyPolicy,
        url.confirmInquiry,
        url.initialRegisterInfoEdit,
        url.initialRegisterInfoConfirm,
        url.initialRegisterInfoDone,
        url.confirmSubAgreement,
        // 課金-ADD-START
        url.confirmSubPaymentAgreement,
        // 課金-ADD-END
        url.confirmSubPrivacyPolicy,
        url.confirmSubInquiry,
      ].indexOf(pathname) !== -1;
    const isAuth0 = state === authStateEnum.auth0;
    const isLogin = isAuth0 || isWeb;
    return (
      <React.Fragment>
        <Helmet>
          <title>{title}</title>
        </Helmet>
        <div>
          <div className="flex-row full-width">
            {isShow && <SiderBar />}
            <div id="content" className="content">
              {isShow && scMode !== modeEnum.pageEditing && <Header />}
              <div
                id="content-main-container"
                className={`content-main-container ${
                  isWeb && isMobile()
                    ? "content-main-container-all-space"
                    : (isWeb && !isMobile()) || (!isWeb && isMobile())
                    ? "content-main-container-space"
                    : ""
                } ${
                  scMode === modeEnum.pageEditing
                    ? "content-main-container-editing-space"
                    : ""
                } ${
                  !isShow ? "content-main-container-no-authorized-space" : ""
                } ${!isLogin ? "login-before-background-color" : ""}`}
              >
                {/* TDS_CMS-425 IEからアクセスされた際にはIEは対応していない旨を帯でメッセージ表示する */}
                {isIEBrowser() &&
                  [url.confirmAgreement].indexOf(pathname) !== -1 && (
                    <div className={`ie-red-bar`}>
                      <div>{i18n.t("TCCs0018_lp_ie_red_tip")}</div>
                    </div>
                  )}
                <div
                  id="content-main"
                  className={`content-main content-main-padding ${
                    !isShow ? "content-main-no-authorized" : ""
                  }`}
                >
                  {placeholders && JSON.stringify(placeholders) !== "{}" ? (
                    <React.Fragment>
                      {Object.keys(placeholders).map((key, index) => {
                        if (
                          placeholders[key] &&
                          placeholders[key].filter(
                            (item) => item.uid && item.componentName
                          ).length > 0
                        ) {
                          const temp = key.replace("jss-", "").split("-");
                          const name = temp.reduce((previous, current) => {
                            return (
                              previous +
                              current.charAt(0).toUpperCase() +
                              current.slice(1)
                            );
                          });
                          if (this[`${name}PlaceholderRender`]) {
                            return (
                              <Placeholder
                                key={index}
                                name={key}
                                rendering={route}
                                routeData={route}
                                router={router}
                                context={sitecoreContext}
                                render={this[`${name}PlaceholderRender`]}
                              />
                            );
                          }
                        }
                        return null;
                      })}
                    </React.Fragment>
                  ) : null}
                </div>
                {isShow && <Footer />}
                {isConfirm && <ConfirmFooter />}
              </div>
            </div>
          </div>
        </div>
        {/* {scMode === modeEnum.dev && <ConfirmUpdateMask />} */}
        {isShow && isNormal && !isWeb && <ConfirmUpdateMask />}
        <ToastContainer />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    state: state?.user?.authState,
    firstLoginStatus: state?.user?.firstLoginStatus,
    companyUpdateStatus: state?.user?.companyUpdateStatus,
    userProfileUpdateStatus: state?.user?.userProfileUpdateStatus,
    agreementStatusInfo: state?.user?.agreementStatusInfo,
    title: state?.config?.navigationTitle,
    scMode: state?.config?.mode,
    currentRouter: state?.config?.configRouter,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateRouter: (action) => dispatch(updateRouterDispatch(action)),
    getMenuBadgeInfo: () => dispatch(getMenuBadgeInfoDispatch()),
    getInformationBadgeInfo: () => dispatch(getInformationBadgeInfoDispatch()),
    // 課金-ADD-START
    getHeaderInfo: () => dispatch(getHeaderInfoDispatch()),
    // 課金-ADD-END
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Layout);
